export const USER_ROLES = {
  CEO: 'CEO',
  ADMINISTRATOR: 'ADMINISTRATOR',
  OPERATOR: 'OPERATOR',
  CUSTOMER: 'CUSTOMER',
};

export const USER_STATUS = {
  PENDING: 'PENDING',
  JOINED: 'JOINED',
  DELETED: 'DELETED',
};

export const USER_LANGUAGE = {
  FRENCH: 'FRENCH',
  ENGLISH: 'ENGLISH',
};
